// extracted by mini-css-extract-plugin
export default {"card":"Card_seeAll_card__1uqOR","title":"Card_seeAll_title__OlUWw","genre":"Card_seeAll_genre__YTctB"};